import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useHistory } from "react-router-dom";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";
import CustomPagination from "../../Components/Common/CustomPagination";
import Loader from "../../Components/Common/Loader";
import BulkCreateFlashcardsModal from "./BulkCreateFlashcardsModal";

const MenuManagement = () => {
  const [activeCategory, setActiveCategory] = useState("");
  const history = useHistory();
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState('$');
  const [statusFilter, setStatusFilter] = useState("");
  const [flashCompletedCount, setFlashCompletedCount] = useState(0);
  const [flashInCompletedCount, setFlashInCompletedCount] = useState(0);
  const [classificationData, setClassificationData] = useState([]);
  const { courses, currentOutlet } = useSelector((state) => ({
        courses: state.Dashboard.filterData.courses || [],
        currentOutlet: state.UserOutletGroup.currentOutlet
  }));
  const [addDishModal, setAddDishModal] = useState(false);
  const toggleAddDish = () => setAddDishModal(!addDishModal);
  const [bulkFlashModal, setBulkFlashModal] = useState(false);
  const toggleBulkFlash = () => setBulkFlashModal(!bulkFlashModal);
  const [recipeTab, setRecipeTab] = useState("text");

  const [editDishModal, setEditDishModal] = useState(false);
  const [editingDish, setEditingDish] = useState(null);
  const toggleEditDishModal = () => setEditDishModal(!editDishModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletingDish, setDeletingDish] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const importFileInputRef = useRef(null);
  const [importFile, setImportFile] = useState(null);
  const [importModal, setImportModal] = useState(false);
  // CHANGED: Added errors array to message state
  const [message, setMessage] = useState({ text: "", type: "", errors: [] });
  const [isImportSuccess, setIsImportSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: ""
  });
  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
    fetchClassificationData();
  }, [currentOutlet]);
  const categories = React.useMemo(() => {
    return [{ label: "All", value: "" }, ...(courses || [])];
  }, [courses]);
  // const categories = React.useMemo(() => {
  //   const filteredCourses = (courses || []).filter(
  //     (c) => c.label !== "Kitchen Instructions"
  //   );

  //   return [{ label: "All", value: "" }, ...filteredCourses];
  // }, [courses]);

  
  const [pageCount, setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);

   const courseColorMap = useMemo(() => {
        const map = new Map();
  
        courses.forEach(course => {
            if (course.label) {
                map.set(course.label, {
                    bg: course.badge_bg || null,
                    text: course.badge_text || null,
                });
            }
        });
  
        return map;
    }, [courses]);
  
    /**
     * Get full badge style by label
     */
    const getColorByLabel = (label) => {
        const colorObj = courseColorMap.get(label);
  
        if (!colorObj || !colorObj.bg) {
            return {
              backgroundColor: "#405189",
              color: "#FFFFFF"
            }; // No color assigned
        }
  
        return {
            backgroundColor: colorObj.bg,
            color: colorObj.text || "#000000",
        };
    };

  const handleCategoryClick = (cat) => {
    setActiveCategory(cat.value);
    fetchMenuItems(cat.value, statusFilter, debouncedSearch);
  };

  const handleStatusFilter = (status) => {
    setStatusFilter(status);
    fetchMenuItems(activeCategory, status, debouncedSearch);
  };

  const controllerRef = useRef(null);
  useEffect(() => {
    fetchMenuItems("","",debouncedSearch);
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [currentOutlet, selectedPage, debouncedSearch]);

  const fetchMenuItems = (categoryId = "", flashStatus = "", search = "") => {
    // cancel previous request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    setLoading(true);
    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_outlet_items",
      display_classcification: "Yes",
      type: "Item",
      status: "Active",
      load: selectedPage+1,
      is_show_all: false,
      course_id: categoryId,
      flash_status: flashStatus,
      search: search
    }, controller.signal)
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          setDishes(res.data.server_data || []);
          setPageCount(Math.ceil(parseInt(res.data.total_records) / 18));
          setFlashCompletedCount(res.data.total_flash_complete_records);
          setFlashInCompletedCount(res.data.total_flash_incomplete_records);
        }
      }).catch((err) => {
        if (err.code === "ERR_CANCELED") {
          console.log("Request cancelled");
          return;
        }
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchClassificationData = () => {
    postDataAPI({
      serviceName: "classifications_data",
      op: "outlet_type_dropdown"
    })
      .then((res) => {
        if (res.status === "ok") {
          setClassificationData(res.data);
        }
      });
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 600); // ⏱ debounce delay

    return () => clearTimeout(timer);
  }, [searchText]);


  const handleAddDish = () => {
    if (!formData.name || !formData.type) {
      alert("Dish name and type are required");
      return;
    }
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_item_create_update",
      dishName: formData.name,
      type: formData.type,
      description: formData.description || ""
    })
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          toggleAddDish(); 
          fetchMenuItems();
          setFormData({
            name: "",
            description: "",
            type: ""
          });
        } else {
          alert(res.message || "Failed to add dish");
        }
      });
  };

  const handleUpdateDish = () => {
    if (
      !editingDish?.item_name ||
      !editingDish?.OutletType_key
    ) {
      alert("Dish name and type are required");
      return;
    }
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_item_create_update",
      item_id: editingDish.item_id,
      dishName: editingDish.item_name,
      type: editingDish.OutletType_key,
      description: editingDish.item_description || ""
    })
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          toggleEditDishModal();   // close modal
          fetchMenuItems();        // refresh list
        } else {
          alert(res.message || "Failed to update dish");
        }
      });
  };

  const handleDeleteDish = () => {
    if (!deletingDish?.item_id) {
      alert("No dish selected for deletion");
      return;
    }

    postDataAPI({
      serviceName: "server_data",
      op: "server_coaching_remove_item",
      item_id: deletingDish.item_id
    })
      .then((res) => {
        if (res.status === "ok") {
          fetchMenuItems();
          toggleDeleteModal();
        } else {
          alert(res.message || "Failed to delete dish");
        }
      });
  };

  const handleExport = async () => {
    try {
      const res = await postDataAPI({
        serviceName: "outlet_data",
        op: "preare_sample_csv",
        export_type: "training",
        server_coaching: true,
        course_id: activeCategory || ""
      });

      if (res.status !== "ok") {
        throw new Error(res.message || "Export failed");
      }

      const filename = res.data;
      if (!filename || typeof filename !== "string") {
        throw new Error("Export response did not contain a filename");
      }

      const apiUrl = process.env.REACT_APP_ITEM_EXPORT_URL;
      const downloadLink = document.createElement("a");
      downloadLink.href = `${apiUrl}${filename}`;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error("EXPORT ERROR:", error);
    }
  };


  // CHANGED: Updated handleImport function with error list handling and no auto-close on success
  const handleImport = async () => {
    if (!importFile) {
      setMessage({ text: "Please select an Excel file", type: "error", errors: [] });
      return;
    }

    try {
      setLoading(true);
      setMessage({ text: "", type: "", errors: [] });
      setIsImportSuccess(false);
      
      const res = await postDataAPI({
        op: "uploadOutletTrainingItemFile",
        serviceName: "item_data",
        item_training_csv_file: importFile,
        mediaType: "Q"
      });

      if (res.status === "ok") {
        // Success - keep modal open to show success message
        setIsImportSuccess(true);
        setMessage({ 
          text: res.message || "Import successful! Menu items have been updated.", 
          type: "success",
          errors: []
        });
        setImportFile(null);
        fetchMenuItems(activeCategory, statusFilter, debouncedSearch);
        
        // Clear file input
        if (importFileInputRef.current) {
          importFileInputRef.current.value = "";
        }
      } else {
        // Error with possible validation errors
        let errorText = res.message || "Import failed";
        let errorList = [];
        
        // Check for validation errors array from backend
        if (res.data && res.data.errors && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
          errorList = res.data.errors;
          errorText = res.message || "Validation errors found:";
        }
        
        setMessage({ 
          text: errorText, 
          type: "error",
          errors: errorList
        });
        setIsImportSuccess(false);
        setImportFile(null);
        
        // Scroll to error message
        setTimeout(() => {
          const errorContainer = document.getElementById('import-error-container');
          if (errorContainer) {
            errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
    } catch (error) {
      console.error("IMPORT ERROR:", error);
      setIsImportSuccess(false);
      setMessage({ 
        text: error.message || "Import failed. Please check your file and try again.", 
        type: "error",
        errors: []
      });
      setImportFile(null);
    } finally {
      setLoading(false);
    }
  };

  // CHANGED: Updated to clear errors array
  const handleImportFileChange = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";

    setMessage({ text: "", type: "", errors: [] });
    setIsImportSuccess(false);

    if (!file) {
      return;
    }

    if (!/\.xlsx?$/i.test(file.name)) {
      setMessage({ 
        text: "Please select an Excel file (.xls or .xlsx)", 
        type: "error",
        errors: []
      });
      setImportFile(null);
      return;
    }

    setImportFile(file);
  };

  // CHANGED: Updated to clear errors array
  const handleImportModalClose = () => {
    setImportModal(false);
    setMessage({ text: "", type: "", errors: [] });
    setImportFile(null);
    setIsImportSuccess(false);
    if (importFileInputRef.current) {
      importFileInputRef.current.value = "";
    }
  };


  return (
    <React.Fragment>
    <UiContent />
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Menu Management" pageTitle="Dashboard &nbsp; > &nbsp; Server Performance Coaching" />

        {/* Top Controls */}
        <Row className="align-items-center mb-3 g-2">
          <Col lg="3">
            <Input
              placeholder="🔍 Search dishes..."
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setSelectedPage(0); // reset pagination on search
              }}
            />
          </Col>

          <Col lg="9" className="text-end">
            <Button outline  className="me-2"
                onClick={() => history.push("/server-performance-coaching")}
            >
                ⬅ Back to Home
            </Button>
            <Button outline color="primary" className="me-2"
                 onClick={handleExport}
            >
              Export Menu Items
            </Button>
            <Button outline color="primary" className="me-2"
              onClick={() => {
                setImportModal(true);
                setMessage({ text: "", type: "", errors: [] });
                setImportFile(null);
                setIsImportSuccess(false);
                if (importFileInputRef.current) {
                  importFileInputRef.current.value = "";
                }
              }}
              disabled={loading}
            >
              Import & Update Menu Items
            </Button>
            <Button outline color="primary" className="me-2" onClick={toggleBulkFlash}>
              Create Flashcards in Bulk
            </Button>
            <Button color="primary" onClick={toggleAddDish}>
              ＋ Add New Dish
            </Button>
          </Col>
        </Row>

        {/* Category Filters */}
        <Row className="mb-4">
        <Col className="d-flex flex-wrap gap-2 col-7">
          {categories.map((cat) => {
            //const color = categoryColorMap[cat.value];
            const color = "#405189";

            return (
              <Button
                key={cat.value}
                size="sm"
                onClick={() => handleCategoryClick(cat)}
                style={{
                  backgroundColor:
                    activeCategory === cat.value ? getColorByLabel(cat.label).backgroundColor : "transparent",
                  borderColor: getColorByLabel(cat.label).backgroundColor,
                  color:
                    activeCategory === cat.value ? getColorByLabel(cat.label).color : "#000"
                }}
              >
                {cat.label}
              </Button>
            );
          })}
        </Col>

        <Col className="d-flex gap-2 align-items-center col-5 justify-content-end">
          <Badge color="secondary" pill className="p-2">
            ⏱ Incomplete ({flashInCompletedCount})
          </Badge>
          <Badge color="secondary" pill className="p-2">
            ✔ Complete ({flashCompletedCount})
          </Badge>

          <Button
            size="sm"
            color={statusFilter === "" ? "secondary" : "secondary"}
            outline={statusFilter !== ""}
            onClick={() => handleStatusFilter("")}
          >
            All
          </Button>

          <Button
            size="sm"
            color={statusFilter === "Incomplete" ? "secondary" : "secondary"}
            outline={statusFilter !== "Incomplete"}
            onClick={() => handleStatusFilter("Incomplete")}
          >
            Incomplete
          </Button>

          <Button
            size="sm"
            color={statusFilter === "Complete" ? "secondary" : "secondary"}
            outline={statusFilter !== "Complete"}
            onClick={() => handleStatusFilter("Complete")}
          >
            Complete
          </Button>
        </Col>

        </Row>


        {/* Dish Cards */}
        {loading && <Loader />}  
        <Row className={loading ? "opacity-0 g-4 mb-5" : "g-4 mb-5"}>
          {dishes.map(dish => (
            <Col key={dish.item_id} lg="4" md="6">
              <Card className=" h-100">
                <CardBody>
                  {/* Header */}
                  <div className="d-flex justify-content-between">
                    <h6 className="fw-bold mb-1">{dish.item_name}</h6>
                    <div className="fs-5 d-flex gap-0">
                        <i
                          className="ri-edit-box-line text-muted action-icon"
                          title="Edit"
                          onClick={(e) => {
                            console.log(dish);
                            
                            e.stopPropagation();
                            setEditingDish(dish);
                            setEditDishModal(true);
                          }}
                        />
                        <i
                          className="ri-delete-bin-line text-danger action-icon"
                          title="Delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeletingDish(dish);
                            setDeleteModal(true);
                          }}
                        />
                        </div>

                  </div>

                  <div className="mb-2">
                    <Badge
                      className="me-2 badge-course"
                     // style={{ "--badge-color": getColorByLabel(dish.course_name) }}
                      style={{"--badge-color": getColorByLabel(dish.course_name).backgroundColor, "--badge-text": getColorByLabel(dish.course_name).color}}
                      pill
                    >
                      {dish.course_name}
                    </Badge>

                    <span className="text-muted small">
                      · {currency}{dish.price}
                    </span>
                  </div>

                  <p className="text-muted small">
                    {dish.item_description}
                  </p>

                  <Button
                    color={dish.flash_id ? "success" : "secondary"}
                    block
                    onClick={() => {
                      if (dish.flash_id) {
                        history.push(`/flash-cards`);
                      } else {
                        history.push(`/create-flash-card`, { dish, badgeColor: getColorByLabel(dish.course_name) });
                      }
                    }}
                  >
                    {dish.flash_id ? "🎓 Flashcard" : "🎓 Create Flash Card"}
                  </Button>

                </CardBody>
              </Card>
            </Col>
          ))}
          <CustomPagination
            pageCount={pageCount}
            setSelectedPage={setSelectedPage}
          />
        </Row>

        {/* CHANGED: Updated Import Modal with error list and success message */}
        <Modal
          isOpen={importModal}
          toggle={handleImportModalClose}
          centered
        >
          <ModalHeader toggle={handleImportModalClose}>
            Import Menu Items
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Excel File</Label>
              <Input
                innerRef={importFileInputRef}
                type="file"
                accept=".xls,.xlsx"
                onChange={handleImportFileChange}
                disabled={loading || isImportSuccess}
              />
              {importFile && !isImportSuccess && (  
                <div className="text-muted small mt-2">{importFile.name}</div>
              )}
            </FormGroup>
            
            {/* CHANGED: Updated message display with error list */}
            {message.text && (
              <div 
                id="import-error-container"
                className={`mt-3 p-3 rounded ${
                  message.type === "success" 
                    ? "alert alert-success" 
                    : "alert alert-danger"
                }`}
                style={{ 
                  border: `1px solid ${
                    message.type === "success" ? "#c3e6cb" : "#f5c6cb"
                  }`
                }}
              >
                <div className="fw-bold">{message.text}</div>
                
                {/* Display error list if exists */}
                {message.errors && message.errors.length > 0 && (
                  <ul className="mb-0 mt-2" style={{ paddingLeft: '20px' }}>
                    {message.errors.map((err, index) => (
                      <li key={index} className="mb-1">{err}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button 
              outline 
              onClick={handleImportModalClose} 
              disabled={loading}
            >
              {isImportSuccess ? "Close" : "Cancel"}
            </Button>
            <Button 
              color="primary" 
              onClick={handleImport} 
              disabled={loading || !importFile || isImportSuccess}
            >
              {loading ? "Importing..." : isImportSuccess ? "✓ Imported" : "Submit"}
            </Button>
          </ModalFooter>
        </Modal>


        <Modal
          isOpen={addDishModal}
          toggle={toggleAddDish}
          centered
        >
          <ModalHeader toggle={toggleAddDish}>
            Add Dish
            <p className="text-muted small mb-0">
              Add the details of your dish
            </p>
          </ModalHeader>

          <ModalBody>
            <FormGroup>
              <Label>Dish Name</Label>
              <Input
                type="text"
                placeholder="e.g., Today's Special Pasta"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Description</Label>
              <Input
                type="textarea"
                rows="4"
                placeholder="Describe the dish"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Type</Label>
              <Input
                type="select"
                value={formData.type}
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
              >
                <option value="">Select a type</option>
                {classificationData?.map((c) => (
                  <option key={c.cfv_id} value={c.cfv_id}>
                    {c.cfv_name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button outline onClick={toggleAddDish}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleAddDish}
              disabled={loading}
            >
              {loading ? "Saving..." : "Add Dish"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={editDishModal}
          toggle={toggleEditDishModal}
          centered
        >
          <ModalHeader toggle={toggleEditDishModal}>
            Edit Dish
            <p className="text-muted small mb-0">
              Update the details of your dish
            </p>
          </ModalHeader>

          <ModalBody>
            {/* Dish Name */}
            <FormGroup>
              <Label>Dish Name</Label>
              <Input
                type="text"
                value={editingDish?.item_name || ""}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    item_name: e.target.value
                  })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Description</Label>
              <Input
                type="textarea"
                rows="4"
                placeholder="Describe the dish"
                value={editingDish?.item_description || ""}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    item_description: e.target.value
                  })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Type</Label>
              <Input
                type="select"
                value={`${editingDish?.OutletType_key || ""}`}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    OutletType_key: e.target.value
                  })
                }
              >
                <option value="">Select a type</option>
                {classificationData?.map((c) => (
                  <option key={c.cfv_id} value={c.cfv_id}>
                    {c.cfv_name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button outline onClick={toggleEditDishModal}>
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={handleUpdateDish}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </ModalFooter>
        </Modal>

        <BulkCreateFlashcardsModal
          isOpen={bulkFlashModal}
          toggle={toggleBulkFlash}
          currency={currency}
          onQueued={() => fetchMenuItems(activeCategory, statusFilter, debouncedSearch)}
        />

        <Modal
          isOpen={deleteModal}
          toggle={toggleDeleteModal}
          centered
          size="md"
        >
          <ModalBody className="p-4">
            <h5 className="fw-semibold mb-2">
              Delete {deletingDish?.item_name}?
            </h5>

            <p className="text-muted mb-4">
              This action cannot be undone. This will permanently delete the dish
              and any associated training data.
            </p>

            <div className="d-flex justify-content-end gap-2">
              <Button outline onClick={toggleDeleteModal}>
                Cancel
              </Button>

              <Button 
               color="danger"
               onClick={handleDeleteDish}
               disabled={loading}
              >
                Delete
              </Button>
            </div>
          </ModalBody>
        </Modal>


      
      </Container>
    </div>
    </React.Fragment>
  );
};

export default MenuManagement;